/**
 * Helper function to fix common Mermaid syntax issues
 * @param {string} code - The raw Mermaid code
 * @returns {string} - Fixed Mermaid code
 */
export const fixMermaidSyntax = (code) => {
  if (!code) return '';

  let fixedCode = code;

  // Fix classDef end -> classDef endNode
  fixedCode = fixedCode.replace(/classDef\s+end\s+/g, 'classDef endNode ');

  // Fix incomplete stroke declarations
  fixedCode = fixedCode.replace(/,\s*str(?=[,\s}])/g, ',stroke:#333');

  // Fix class assignments with 'end' keyword
  fixedCode = fixedCode.replace(/class\s+(\w+)\s+end(?=[,\s}])/g, 'class $1 "endNode"');

  return fixedCode;
};
